export const prefix = 'side-nav';

export { default } from './SideNavBar';
